import { Typography } from '@prenuvo/halo';

import { DESCRIPTION_GUIDES } from '../report-issue-handler.constant';
import { useReportIssueHandler } from '../use-report-issue-handler.hook';

export function ReportDescriptionGuide() {
  const { issueType } = useReportIssueHandler();

  const guide = DESCRIPTION_GUIDES[issueType as keyof typeof DESCRIPTION_GUIDES];

  if (!guide) {
    return null;
  }

  return (
    <div>
      <Typography
        className="mb-2 font-semibold"
        translationKey={guide.title}
        variant="paragraph-md"
      />
      <ul className="list-disc space-y-1 px-4">
        {guide.items.map((item) => (
          <li key={item}>
            <Typography translationKey={item} variant="paragraph-sm" />
          </li>
        ))}
      </ul>
    </div>
  );
}
